/**
 * Canonical enum values for categorical metrics with fixed option lists.
 *
 * These constants are the single source of truth for:
 *  - Backend transport validation for metric records
 *  - TypeScript union types (types/metrics/metadata.ts)
 *  - Config UI option lists (CustomEndReasonConfig, CustomAudioSentimentConfig)
 *  - Categorical metric record `getCategoricalOptions()` overrides
 *
 * Keep the backend Django model enums in sync with these values.
 */

export const END_REASON_VALUES = [
  "IDLE_TIMEOUT",
  "DURATION_LIMIT",
  "PERSONA_DISCONNECTED",
  "AGENT_DISCONNECTED",
  "AGENT_END_CUE",
  "PIPELINE_ERROR",
  "REPETITION_LOOP",
  "AUDIO_UPLOAD_PLAYBACK_COMPLETED",
  "SCRIPT_COMPLETED",
  "SCRIPT_DIVERGED",
  "UNKNOWN",
] as const

export type EndReason = (typeof END_REASON_VALUES)[number]

export const END_REASON_LABELS: Record<EndReason, string> = {
  IDLE_TIMEOUT: "Idle Timeout",
  DURATION_LIMIT: "Duration Limit",
  PERSONA_DISCONNECTED: "Persona Disconnected",
  AGENT_DISCONNECTED: "Agent Disconnected",
  AGENT_END_CUE: "Agent End Cue",
  PIPELINE_ERROR: "Pipeline Error",
  REPETITION_LOOP: "Repetition Loop",
  AUDIO_UPLOAD_PLAYBACK_COMPLETED: "Audio Playback Completed",
  SCRIPT_COMPLETED: "Script Completed",
  SCRIPT_DIVERGED: "Script Diverged",
  UNKNOWN: "Unknown",
}

export const AUDIO_SENTIMENT_VALUES = [
  "Neutral",
  "Happy",
  "Angry",
  "Sad",
] as const

export type AudioSentiment = (typeof AUDIO_SENTIMENT_VALUES)[number]
